import ModalWithJoin from './ModalWithJoin';

export default ModalWithJoin;
